<template>
  <div
    v-show="isActive"
    class="is-uploading has-background-white"
  >
    <div class="text">
      <span
        v-show="printName && !submittingFileName && !errorMessage"
        class="is-text-overflow"
      >
        {{ String(printName).replace(/^.*[\\\/]/, '') }}
      </span>
      <span
        v-show="errorMessage"
        class="has-text-danger has-text-weight-bold is-text-overflow"
      >
        {{ errorMessage }}
        <button
          class="button is-text is-small p-l-xs p-r-xs is-vertical-align-middle tryagain-button"
          @click="upload(file)"
        >
          try again
        </button>
      </span>
      <span
        v-show="submittingFileName"
        class=""
      >
        Uploading: <i>{{ submittingFileName }}</i>
      </span>
    </div>
    <div class="action">
      <a
        class="delete"
        aria-label="remove file"
        :aria-disabled="removing"
        :disabled="removing"
        @click="reset"
      >
        x
      </a>
    </div>
    <progress
      v-show="percentage > 0"
      class="progress is-success is-small"
      :class="{ 'is-danger': errorMessage }"
      max="100"
      :value="percentage"
    >
      {{ percentage }}%
    </progress>
  </div>
</template>

<script>
import { objectToFormData } from 'object-to-formdata';

export default {
  props: {
    // file: {
    //   type: File,
    //   required: false,
    //   default: () => (null),
    // },
    // In case of a custom parameter name for file.
    requestParametersController: {
      type: Function,
      required: false,
      default: null,
    },
    responseParametersController: {
      type: Function,
      required: false,
      default: null,
    },
    removeParametersController: {
      type: Function,
      required: false,
      default: null,
    },
    url: {
      type: String,
      require: false,
      default: '',
    },
    removeUrl: {
      type: String,
      required: false,
      default: '',
    },
    removeGuard: {
      type: Function,
      required: false,
      default: () => {
        return Promise.resolve(true); 
      },
    },
    value: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      percentage: 0,
      animationInterval: null,
      errorMessage: null,
      submittingFileName: null,
      cancelToken: null,
      lastResponseData: {},
      removing: false,
      file: null,
    };
  },
  computed: {
    isActive() {
      return !!(this.printName
      || this.submittingFileName
      || this.errorMessage);
    },
    printName: {
      get() {
        return this.value;
      },
      set(name) {
        this.$emit('input', name);
      },
    },
  },
  watch: {
    // file(newValue) {
    //   if (newValue !== null) {
    //     this.upload();
    //   }
    // },
  },
  // beforeMount() {
  //   if (this.file) {
  //     this.upload();
  //   }
  // },
  mounted() {
  },
  methods: {
    cancel() {
      if (this.cancelToken) {
        this.cancelToken.cancel();
        this.cancelToken = null;
      }
    },

    async reset() {
      this.cancel();

      let response = {};
      if (this.printName) {
        const guard = await this.removeGuard(this.lastResponseData);
        if (!guard) {
          return;
        }

        this.removing = true;

        try {
          this.cancelToken = this.$axios.CancelToken.source();
          if (this.removeUrl) {
            let formData = {
              'file': this.lastResponseData.file,
            };
            if (this.removeParametersController) {
              formData = this.removeParametersController(this.lastResponseData);
            }
            response = await this.$axios.delete(
              this.removeUrl,
              {
                data: formData,
              },
              {
                cancelToken: this.cancelToken.token,
              }
            );
          }
        } catch (err) {
          response = err;
          // TODO: I will ignore file removal, implement this post MVP.
        }
        this.removing = false;
      }

      Object.assign(this.$data, this.$options.data());
      if (this.value !== '' 
        && (!this.submittingFileName && !this.errorMessage)) {
        this.printName = null;
      }

      this.$emit('reset', response);
    },

    finishInterval() {
      this.submittingFileName = null;
      this.percentage = 100;
      setTimeout(() => {
        this.percentage = 0;
      }, 400);
    },

    async upload(file) {
      this.file = file;
      this.errorMessage = null;
      this.submittingFileName = this.file.name;

      this.percentage = 1;

      let submitData = {};

      if (this.requestParametersController) {
        submitData = this.requestParametersController(this.file);
      } else {
        submitData.file = File;
      }
      return await this.submit(submitData);
    },

    onUploadProgress(progressEvent) {
      if (progressEvent.isTrusted) {
        this.percentage = Math.ceil((progressEvent.loaded / progressEvent.total)*100); 
      }
    },

    async submit(formData) {
      const unknownError = 'File uploading has failed.';

      this.cancel();

      try {
        this.cancelToken = this.$axios.CancelToken.source();

        const response = await this.$axios.post(
          this.url,
          objectToFormData(formData), {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            cancelToken: this.cancelToken.token,
            onUploadProgress: this.onUploadProgress,
          }
        );

        this.finishInterval();

        if (response.data) {
          this.lastResponseData = response.data;

          if (this.responseParametersController) {
            this.printName = this.responseParametersController(response); 
          } else {
            this.printName = response.data.file;
          }
          this.file = null;
          return true;
        } 
        this.errorMessage = unknownError;
        return false;
        
      } catch (err) {
        if (this.$axios.isCancel(err)) {
          return false;
        }

        this.finishInterval();

        let message = this.$helpers.findDeepProp('response.data.message', err);
        if (message) {
          this.errorMessage = message;
        } else {
          this.errorMessage = unknownError;
        }
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .is-uploading {
    position: relative;
    display: table;
    width: 100%;
    table-layout: fixed;
    padding: 0.5rem;
    .text, .action {
      display: table-cell;
      vertical-align: middle;
    }
    .text {
      // width: calc(100% - 30px);
      width: 100%;
    }
    .action {
      width: 30px;
      text-align: center;
      white-space:nowrap;
    }
    .progress{
      transition: all 0.1s linear;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      border-radius: 0;
      height: 3px;
    }
  }
</style>